import { Settings } from "../utils/settings";
import { asArray } from "../utils/tools";
import { Debug } from "../components/debug";
import get from "lodash/get";

export const elemLabel = (elem, caller, _default) => {
  const label =
    asArray(elem)
      .map(
        (el) =>
          get(el, "props.label") || get(el, "props.className", "").split(" ")[0]
      )
      .filter((v) => v)
      .join(", ") || _default;

  if (!label) {
    console.warn(
      `${caller}:: Empty label, please add label for easier debugging`
    );

    return "unknown";
  }

  return label;
};

const canLabel = (can) =>
  asArray(can)
    .map((_can) => {
      const resource = get(_can, "resource");
      const action = get(_can, "action");
      const filters = asArray(_can?.filters)
        .filter((v) => v)
        .join("_");

      const label = [resource, action, filters].filter((v) => v).join("..");

      return resource || action ? `[${label}]` : `[${JSON.stringify(_can)}]`;
    })
    .join(", ");

export const NoAccess = ({ label, can, ...rest }) => {
  label = canLabel(can) + ` (${label})`;

  return Settings.getDebugSetting("show_restricted_elements") ? (
    <Debug {...rest} className={"NoAccess"}>
      Unauthorized: {label}
    </Debug>
  ) : null;
};
